// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-l_hk","advertDetailServiceList__header":"c-l_hl","advertDetailServiceList__list":"c-l_hm"};